import React from 'react'

import { BrandedAlertModal } from 'components/Modal'
import type { BrandedAction } from 'components/Modal/BrandedAlertModal/BrandedAlertModal'

interface ShowContactsActionProps {
    isOpen: boolean
    onConfirm: () => void
    onCancel: () => void
}

// T2-6644: use shared BrandedAlertModal (max-width ~420px) instead of the
// full-bleed Popup shell so this matches other Job Board confirm dialogs.
const ShowContactsAction = ({
    isOpen,
    onConfirm,
    onCancel,
}: ShowContactsActionProps) => {
    const actions: BrandedAction[] = [
        {
            label: 'No',
            variant: 'secondary',
            onClick: onCancel,
            ariaLabel: 'cancel-button',
        },
        {
            label: 'Yes',
            variant: 'primary',
            onClick: onConfirm,
            ariaLabel: 'confirm-button',
        },
    ]

    return (
        <BrandedAlertModal
            isOpen={isOpen}
            onClose={onCancel}
            title="Allow candidate to see Office Contact Info?"
            ariaLabel="Allow candidate to see Office Contact Info"
            actions={actions}
        >
            <p>Do you want to allow the candidate to see Office Contact Info?</p>
        </BrandedAlertModal>
    )
}

export default ShowContactsAction;
